/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AdminRouteImport } from './routes/_admin';
import { Route as R403RouteImport } from './routes/403';
import { Route as AdminIndexRouteImport } from './routes/_admin/index';
import { Route as AdminResourcesRouteImport } from './routes/_admin/resources';
import { Route as AdminNoticesRouteImport } from './routes/_admin/notices';
import { Route as AdminMembersRouteImport } from './routes/_admin/members';
import { Route as AdminInquiriesRouteImport } from './routes/_admin/inquiries';
import { Route as AdminFlywayRouteImport } from './routes/_admin/flyway';
import { Route as AdminFaqsRouteImport } from './routes/_admin/faqs';
import { Route as AdminEventsRouteImport } from './routes/_admin/events';
import { Route as AdminErdRouteImport } from './routes/_admin/erd';
import { Route as AdminChallengesRouteImport } from './routes/_admin/challenges';
import { Route as AdminBlogRouteImport } from './routes/_admin/blog';
import { Route as AdminReviewersIndexRouteImport } from './routes/_admin/reviewers/index';
import { Route as AdminResourcesIndexRouteImport } from './routes/_admin/resources/index';
import { Route as AdminNoticesIndexRouteImport } from './routes/_admin/notices/index';
import { Route as AdminNewslettersIndexRouteImport } from './routes/_admin/newsletters/index';
import { Route as AdminInquiriesIndexRouteImport } from './routes/_admin/inquiries/index';
import { Route as AdminFaqsIndexRouteImport } from './routes/_admin/faqs/index';
import { Route as AdminEventsIndexRouteImport } from './routes/_admin/events/index';
import { Route as AdminChallengesIndexRouteImport } from './routes/_admin/challenges/index';
import { Route as AdminBlogIndexRouteImport } from './routes/_admin/blog/index';
import { Route as AdminReviewersStatsRouteImport } from './routes/_admin/reviewers/stats';
import { Route as AdminResourcesUnsubscribePatternRouteImport } from './routes/_admin/resources/unsubscribe-pattern';
import { Route as AdminResourcesUnsubscribeParsePatternRouteImport } from './routes/_admin/resources/unsubscribe-parse-pattern';
import { Route as AdminResourcesUnsubscribeLambdaRouteImport } from './routes/_admin/resources/unsubscribe-lambda';
import { Route as AdminNoticesNewRouteImport } from './routes/_admin/notices/new';
import { Route as AdminNoticesNoticeIdRouteImport } from './routes/_admin/notices/$noticeId';
import { Route as AdminNewslettersNewRouteImport } from './routes/_admin/newsletters/new';
import { Route as AdminNewslettersCategoriesRouteImport } from './routes/_admin/newsletters/categories';
import { Route as AdminNewslettersNewsletterIdRouteImport } from './routes/_admin/newsletters/$newsletterId';
import { Route as AdminInquiriesRoomsRouteImport } from './routes/_admin/inquiries/rooms';
import { Route as AdminFaqsNewRouteImport } from './routes/_admin/faqs/new';
import { Route as AdminFaqsFaqIdRouteImport } from './routes/_admin/faqs/$faqId';
import { Route as AdminEventsEventIdRouteImport } from './routes/_admin/events/$eventId';
import { Route as AdminChallengesDailyGuidesRouteImport } from './routes/_admin/challenges/daily-guides';
import { Route as AdminChallengesChallengeIdRouteImport } from './routes/_admin/challenges/$challengeId';
import { Route as AdminBlogPostIdRouteImport } from './routes/_admin/blog/$postId';
import { Route as AdminResourcesUnsubscribeLambdaIndexRouteImport } from './routes/_admin/resources/unsubscribe-lambda/index';
import { Route as AdminNoticesNoticeIdIndexRouteImport } from './routes/_admin/notices/$noticeId/index';
import { Route as AdminNewslettersNewsletterIdIndexRouteImport } from './routes/_admin/newsletters/$newsletterId/index';
import { Route as AdminFaqsFaqIdIndexRouteImport } from './routes/_admin/faqs/$faqId/index';
import { Route as AdminChallengesChallengeIdIndexRouteImport } from './routes/_admin/challenges/$challengeId/index';
import { Route as AdminResourcesUnsubscribeLambdaEditorRouteImport } from './routes/_admin/resources/unsubscribe-lambda/editor';
import { Route as AdminNoticesNoticeIdEditRouteImport } from './routes/_admin/notices/$noticeId/edit';
import { Route as AdminNewslettersNewsletterIdPreviousRouteImport } from './routes/_admin/newsletters/$newsletterId/previous';
import { Route as AdminNewslettersNewsletterIdEditRouteImport } from './routes/_admin/newsletters/$newsletterId/edit';
import { Route as AdminFaqsFaqIdEditRouteImport } from './routes/_admin/faqs/$faqId/edit';
import { Route as AdminChallengesChallengeIdTeamsRouteImport } from './routes/_admin/challenges/$challengeId/teams';
import { Route as AdminNewslettersNewsletterIdPreviousIndexRouteImport } from './routes/_admin/newsletters/$newsletterId/previous/index';
import { Route as AdminNewslettersNewsletterIdPreviousArticleIdRouteImport } from './routes/_admin/newsletters/$newsletterId/previous.$articleId';

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any);
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminResourcesRoute = AdminResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AdminRoute,
} as any);
const AdminNoticesRoute = AdminNoticesRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => AdminRoute,
} as any);
const AdminMembersRoute = AdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminRoute,
} as any);
const AdminInquiriesRoute = AdminInquiriesRouteImport.update({
  id: '/inquiries',
  path: '/inquiries',
  getParentRoute: () => AdminRoute,
} as any);
const AdminFlywayRoute = AdminFlywayRouteImport.update({
  id: '/flyway',
  path: '/flyway',
  getParentRoute: () => AdminRoute,
} as any);
const AdminFaqsRoute = AdminFaqsRouteImport.update({
  id: '/faqs',
  path: '/faqs',
  getParentRoute: () => AdminRoute,
} as any);
const AdminEventsRoute = AdminEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AdminRoute,
} as any);
const AdminErdRoute = AdminErdRouteImport.update({
  id: '/erd',
  path: '/erd',
  getParentRoute: () => AdminRoute,
} as any);
const AdminChallengesRoute = AdminChallengesRouteImport.update({
  id: '/challenges',
  path: '/challenges',
  getParentRoute: () => AdminRoute,
} as any);
const AdminBlogRoute = AdminBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => AdminRoute,
} as any);
const AdminReviewersIndexRoute = AdminReviewersIndexRouteImport.update({
  id: '/reviewers/',
  path: '/reviewers/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminResourcesIndexRoute = AdminResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminResourcesRoute,
} as any);
const AdminNoticesIndexRoute = AdminNoticesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminNoticesRoute,
} as any);
const AdminNewslettersIndexRoute = AdminNewslettersIndexRouteImport.update({
  id: '/newsletters/',
  path: '/newsletters/',
  getParentRoute: () => AdminRoute,
} as any);
const AdminInquiriesIndexRoute = AdminInquiriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminInquiriesRoute,
} as any);
const AdminFaqsIndexRoute = AdminFaqsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFaqsRoute,
} as any);
const AdminEventsIndexRoute = AdminEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminEventsRoute,
} as any);
const AdminChallengesIndexRoute = AdminChallengesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminChallengesRoute,
} as any);
const AdminBlogIndexRoute = AdminBlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminBlogRoute,
} as any);
const AdminReviewersStatsRoute = AdminReviewersStatsRouteImport.update({
  id: '/reviewers/stats',
  path: '/reviewers/stats',
  getParentRoute: () => AdminRoute,
} as any);
const AdminResourcesUnsubscribePatternRoute =
  AdminResourcesUnsubscribePatternRouteImport.update({
    id: '/unsubscribe-pattern',
    path: '/unsubscribe-pattern',
    getParentRoute: () => AdminResourcesRoute,
  } as any);
const AdminResourcesUnsubscribeParsePatternRoute =
  AdminResourcesUnsubscribeParsePatternRouteImport.update({
    id: '/unsubscribe-parse-pattern',
    path: '/unsubscribe-parse-pattern',
    getParentRoute: () => AdminResourcesRoute,
  } as any);
const AdminResourcesUnsubscribeLambdaRoute =
  AdminResourcesUnsubscribeLambdaRouteImport.update({
    id: '/unsubscribe-lambda',
    path: '/unsubscribe-lambda',
    getParentRoute: () => AdminResourcesRoute,
  } as any);
const AdminNoticesNewRoute = AdminNoticesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminNoticesRoute,
} as any);
const AdminNoticesNoticeIdRoute = AdminNoticesNoticeIdRouteImport.update({
  id: '/$noticeId',
  path: '/$noticeId',
  getParentRoute: () => AdminNoticesRoute,
} as any);
const AdminNewslettersNewRoute = AdminNewslettersNewRouteImport.update({
  id: '/newsletters/new',
  path: '/newsletters/new',
  getParentRoute: () => AdminRoute,
} as any);
const AdminNewslettersCategoriesRoute =
  AdminNewslettersCategoriesRouteImport.update({
    id: '/newsletters/categories',
    path: '/newsletters/categories',
    getParentRoute: () => AdminRoute,
  } as any);
const AdminNewslettersNewsletterIdRoute =
  AdminNewslettersNewsletterIdRouteImport.update({
    id: '/newsletters/$newsletterId',
    path: '/newsletters/$newsletterId',
    getParentRoute: () => AdminRoute,
  } as any);
const AdminInquiriesRoomsRoute = AdminInquiriesRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => AdminInquiriesRoute,
} as any);
const AdminFaqsNewRoute = AdminFaqsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AdminFaqsRoute,
} as any);
const AdminFaqsFaqIdRoute = AdminFaqsFaqIdRouteImport.update({
  id: '/$faqId',
  path: '/$faqId',
  getParentRoute: () => AdminFaqsRoute,
} as any);
const AdminEventsEventIdRoute = AdminEventsEventIdRouteImport.update({
  id: '/$eventId',
  path: '/$eventId',
  getParentRoute: () => AdminEventsRoute,
} as any);
const AdminChallengesDailyGuidesRoute =
  AdminChallengesDailyGuidesRouteImport.update({
    id: '/daily-guides',
    path: '/daily-guides',
    getParentRoute: () => AdminChallengesRoute,
  } as any);
const AdminChallengesChallengeIdRoute =
  AdminChallengesChallengeIdRouteImport.update({
    id: '/$challengeId',
    path: '/$challengeId',
    getParentRoute: () => AdminChallengesRoute,
  } as any);
const AdminBlogPostIdRoute = AdminBlogPostIdRouteImport.update({
  id: '/$postId',
  path: '/$postId',
  getParentRoute: () => AdminBlogRoute,
} as any);
const AdminResourcesUnsubscribeLambdaIndexRoute =
  AdminResourcesUnsubscribeLambdaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminResourcesUnsubscribeLambdaRoute,
  } as any);
const AdminNoticesNoticeIdIndexRoute =
  AdminNoticesNoticeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminNoticesNoticeIdRoute,
  } as any);
const AdminNewslettersNewsletterIdIndexRoute =
  AdminNewslettersNewsletterIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminNewslettersNewsletterIdRoute,
  } as any);
const AdminFaqsFaqIdIndexRoute = AdminFaqsFaqIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFaqsFaqIdRoute,
} as any);
const AdminChallengesChallengeIdIndexRoute =
  AdminChallengesChallengeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminChallengesChallengeIdRoute,
  } as any);
const AdminResourcesUnsubscribeLambdaEditorRoute =
  AdminResourcesUnsubscribeLambdaEditorRouteImport.update({
    id: '/editor',
    path: '/editor',
    getParentRoute: () => AdminResourcesUnsubscribeLambdaRoute,
  } as any);
const AdminNoticesNoticeIdEditRoute =
  AdminNoticesNoticeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdminNoticesNoticeIdRoute,
  } as any);
const AdminNewslettersNewsletterIdPreviousRoute =
  AdminNewslettersNewsletterIdPreviousRouteImport.update({
    id: '/previous',
    path: '/previous',
    getParentRoute: () => AdminNewslettersNewsletterIdRoute,
  } as any);
const AdminNewslettersNewsletterIdEditRoute =
  AdminNewslettersNewsletterIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AdminNewslettersNewsletterIdRoute,
  } as any);
const AdminFaqsFaqIdEditRoute = AdminFaqsFaqIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AdminFaqsFaqIdRoute,
} as any);
const AdminChallengesChallengeIdTeamsRoute =
  AdminChallengesChallengeIdTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => AdminChallengesChallengeIdRoute,
  } as any);
const AdminNewslettersNewsletterIdPreviousIndexRoute =
  AdminNewslettersNewsletterIdPreviousIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminNewslettersNewsletterIdPreviousRoute,
  } as any);
const AdminNewslettersNewsletterIdPreviousArticleIdRoute =
  AdminNewslettersNewsletterIdPreviousArticleIdRouteImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => AdminNewslettersNewsletterIdPreviousRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/403': typeof R403Route;
  '/blog': typeof AdminBlogRouteWithChildren;
  '/challenges': typeof AdminChallengesRouteWithChildren;
  '/erd': typeof AdminErdRoute;
  '/events': typeof AdminEventsRouteWithChildren;
  '/faqs': typeof AdminFaqsRouteWithChildren;
  '/flyway': typeof AdminFlywayRoute;
  '/inquiries': typeof AdminInquiriesRouteWithChildren;
  '/members': typeof AdminMembersRoute;
  '/notices': typeof AdminNoticesRouteWithChildren;
  '/resources': typeof AdminResourcesRouteWithChildren;
  '/': typeof AdminIndexRoute;
  '/blog/$postId': typeof AdminBlogPostIdRoute;
  '/challenges/$challengeId': typeof AdminChallengesChallengeIdRouteWithChildren;
  '/challenges/daily-guides': typeof AdminChallengesDailyGuidesRoute;
  '/events/$eventId': typeof AdminEventsEventIdRoute;
  '/faqs/$faqId': typeof AdminFaqsFaqIdRouteWithChildren;
  '/faqs/new': typeof AdminFaqsNewRoute;
  '/inquiries/rooms': typeof AdminInquiriesRoomsRoute;
  '/newsletters/$newsletterId': typeof AdminNewslettersNewsletterIdRouteWithChildren;
  '/newsletters/categories': typeof AdminNewslettersCategoriesRoute;
  '/newsletters/new': typeof AdminNewslettersNewRoute;
  '/notices/$noticeId': typeof AdminNoticesNoticeIdRouteWithChildren;
  '/notices/new': typeof AdminNoticesNewRoute;
  '/resources/unsubscribe-lambda': typeof AdminResourcesUnsubscribeLambdaRouteWithChildren;
  '/resources/unsubscribe-parse-pattern': typeof AdminResourcesUnsubscribeParsePatternRoute;
  '/resources/unsubscribe-pattern': typeof AdminResourcesUnsubscribePatternRoute;
  '/reviewers/stats': typeof AdminReviewersStatsRoute;
  '/blog/': typeof AdminBlogIndexRoute;
  '/challenges/': typeof AdminChallengesIndexRoute;
  '/events/': typeof AdminEventsIndexRoute;
  '/faqs/': typeof AdminFaqsIndexRoute;
  '/inquiries/': typeof AdminInquiriesIndexRoute;
  '/newsletters': typeof AdminNewslettersIndexRoute;
  '/notices/': typeof AdminNoticesIndexRoute;
  '/resources/': typeof AdminResourcesIndexRoute;
  '/reviewers': typeof AdminReviewersIndexRoute;
  '/challenges/$challengeId/teams': typeof AdminChallengesChallengeIdTeamsRoute;
  '/faqs/$faqId/edit': typeof AdminFaqsFaqIdEditRoute;
  '/newsletters/$newsletterId/edit': typeof AdminNewslettersNewsletterIdEditRoute;
  '/newsletters/$newsletterId/previous': typeof AdminNewslettersNewsletterIdPreviousRouteWithChildren;
  '/notices/$noticeId/edit': typeof AdminNoticesNoticeIdEditRoute;
  '/resources/unsubscribe-lambda/editor': typeof AdminResourcesUnsubscribeLambdaEditorRoute;
  '/challenges/$challengeId/': typeof AdminChallengesChallengeIdIndexRoute;
  '/faqs/$faqId/': typeof AdminFaqsFaqIdIndexRoute;
  '/newsletters/$newsletterId/': typeof AdminNewslettersNewsletterIdIndexRoute;
  '/notices/$noticeId/': typeof AdminNoticesNoticeIdIndexRoute;
  '/resources/unsubscribe-lambda/': typeof AdminResourcesUnsubscribeLambdaIndexRoute;
  '/newsletters/$newsletterId/previous/$articleId': typeof AdminNewslettersNewsletterIdPreviousArticleIdRoute;
  '/newsletters/$newsletterId/previous/': typeof AdminNewslettersNewsletterIdPreviousIndexRoute;
}
export interface FileRoutesByTo {
  '/403': typeof R403Route;
  '/erd': typeof AdminErdRoute;
  '/flyway': typeof AdminFlywayRoute;
  '/members': typeof AdminMembersRoute;
  '/': typeof AdminIndexRoute;
  '/blog/$postId': typeof AdminBlogPostIdRoute;
  '/challenges/daily-guides': typeof AdminChallengesDailyGuidesRoute;
  '/events/$eventId': typeof AdminEventsEventIdRoute;
  '/faqs/new': typeof AdminFaqsNewRoute;
  '/inquiries/rooms': typeof AdminInquiriesRoomsRoute;
  '/newsletters/categories': typeof AdminNewslettersCategoriesRoute;
  '/newsletters/new': typeof AdminNewslettersNewRoute;
  '/notices/new': typeof AdminNoticesNewRoute;
  '/resources/unsubscribe-parse-pattern': typeof AdminResourcesUnsubscribeParsePatternRoute;
  '/resources/unsubscribe-pattern': typeof AdminResourcesUnsubscribePatternRoute;
  '/reviewers/stats': typeof AdminReviewersStatsRoute;
  '/blog': typeof AdminBlogIndexRoute;
  '/challenges': typeof AdminChallengesIndexRoute;
  '/events': typeof AdminEventsIndexRoute;
  '/faqs': typeof AdminFaqsIndexRoute;
  '/inquiries': typeof AdminInquiriesIndexRoute;
  '/newsletters': typeof AdminNewslettersIndexRoute;
  '/notices': typeof AdminNoticesIndexRoute;
  '/resources': typeof AdminResourcesIndexRoute;
  '/reviewers': typeof AdminReviewersIndexRoute;
  '/challenges/$challengeId/teams': typeof AdminChallengesChallengeIdTeamsRoute;
  '/faqs/$faqId/edit': typeof AdminFaqsFaqIdEditRoute;
  '/newsletters/$newsletterId/edit': typeof AdminNewslettersNewsletterIdEditRoute;
  '/notices/$noticeId/edit': typeof AdminNoticesNoticeIdEditRoute;
  '/resources/unsubscribe-lambda/editor': typeof AdminResourcesUnsubscribeLambdaEditorRoute;
  '/challenges/$challengeId': typeof AdminChallengesChallengeIdIndexRoute;
  '/faqs/$faqId': typeof AdminFaqsFaqIdIndexRoute;
  '/newsletters/$newsletterId': typeof AdminNewslettersNewsletterIdIndexRoute;
  '/notices/$noticeId': typeof AdminNoticesNoticeIdIndexRoute;
  '/resources/unsubscribe-lambda': typeof AdminResourcesUnsubscribeLambdaIndexRoute;
  '/newsletters/$newsletterId/previous/$articleId': typeof AdminNewslettersNewsletterIdPreviousArticleIdRoute;
  '/newsletters/$newsletterId/previous': typeof AdminNewslettersNewsletterIdPreviousIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/403': typeof R403Route;
  '/_admin': typeof AdminRouteWithChildren;
  '/_admin/blog': typeof AdminBlogRouteWithChildren;
  '/_admin/challenges': typeof AdminChallengesRouteWithChildren;
  '/_admin/erd': typeof AdminErdRoute;
  '/_admin/events': typeof AdminEventsRouteWithChildren;
  '/_admin/faqs': typeof AdminFaqsRouteWithChildren;
  '/_admin/flyway': typeof AdminFlywayRoute;
  '/_admin/inquiries': typeof AdminInquiriesRouteWithChildren;
  '/_admin/members': typeof AdminMembersRoute;
  '/_admin/notices': typeof AdminNoticesRouteWithChildren;
  '/_admin/resources': typeof AdminResourcesRouteWithChildren;
  '/_admin/': typeof AdminIndexRoute;
  '/_admin/blog/$postId': typeof AdminBlogPostIdRoute;
  '/_admin/challenges/$challengeId': typeof AdminChallengesChallengeIdRouteWithChildren;
  '/_admin/challenges/daily-guides': typeof AdminChallengesDailyGuidesRoute;
  '/_admin/events/$eventId': typeof AdminEventsEventIdRoute;
  '/_admin/faqs/$faqId': typeof AdminFaqsFaqIdRouteWithChildren;
  '/_admin/faqs/new': typeof AdminFaqsNewRoute;
  '/_admin/inquiries/rooms': typeof AdminInquiriesRoomsRoute;
  '/_admin/newsletters/$newsletterId': typeof AdminNewslettersNewsletterIdRouteWithChildren;
  '/_admin/newsletters/categories': typeof AdminNewslettersCategoriesRoute;
  '/_admin/newsletters/new': typeof AdminNewslettersNewRoute;
  '/_admin/notices/$noticeId': typeof AdminNoticesNoticeIdRouteWithChildren;
  '/_admin/notices/new': typeof AdminNoticesNewRoute;
  '/_admin/resources/unsubscribe-lambda': typeof AdminResourcesUnsubscribeLambdaRouteWithChildren;
  '/_admin/resources/unsubscribe-parse-pattern': typeof AdminResourcesUnsubscribeParsePatternRoute;
  '/_admin/resources/unsubscribe-pattern': typeof AdminResourcesUnsubscribePatternRoute;
  '/_admin/reviewers/stats': typeof AdminReviewersStatsRoute;
  '/_admin/blog/': typeof AdminBlogIndexRoute;
  '/_admin/challenges/': typeof AdminChallengesIndexRoute;
  '/_admin/events/': typeof AdminEventsIndexRoute;
  '/_admin/faqs/': typeof AdminFaqsIndexRoute;
  '/_admin/inquiries/': typeof AdminInquiriesIndexRoute;
  '/_admin/newsletters/': typeof AdminNewslettersIndexRoute;
  '/_admin/notices/': typeof AdminNoticesIndexRoute;
  '/_admin/resources/': typeof AdminResourcesIndexRoute;
  '/_admin/reviewers/': typeof AdminReviewersIndexRoute;
  '/_admin/challenges/$challengeId/teams': typeof AdminChallengesChallengeIdTeamsRoute;
  '/_admin/faqs/$faqId/edit': typeof AdminFaqsFaqIdEditRoute;
  '/_admin/newsletters/$newsletterId/edit': typeof AdminNewslettersNewsletterIdEditRoute;
  '/_admin/newsletters/$newsletterId/previous': typeof AdminNewslettersNewsletterIdPreviousRouteWithChildren;
  '/_admin/notices/$noticeId/edit': typeof AdminNoticesNoticeIdEditRoute;
  '/_admin/resources/unsubscribe-lambda/editor': typeof AdminResourcesUnsubscribeLambdaEditorRoute;
  '/_admin/challenges/$challengeId/': typeof AdminChallengesChallengeIdIndexRoute;
  '/_admin/faqs/$faqId/': typeof AdminFaqsFaqIdIndexRoute;
  '/_admin/newsletters/$newsletterId/': typeof AdminNewslettersNewsletterIdIndexRoute;
  '/_admin/notices/$noticeId/': typeof AdminNoticesNoticeIdIndexRoute;
  '/_admin/resources/unsubscribe-lambda/': typeof AdminResourcesUnsubscribeLambdaIndexRoute;
  '/_admin/newsletters/$newsletterId/previous/$articleId': typeof AdminNewslettersNewsletterIdPreviousArticleIdRoute;
  '/_admin/newsletters/$newsletterId/previous/': typeof AdminNewslettersNewsletterIdPreviousIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/403'
    | '/blog'
    | '/challenges'
    | '/erd'
    | '/events'
    | '/faqs'
    | '/flyway'
    | '/inquiries'
    | '/members'
    | '/notices'
    | '/resources'
    | '/'
    | '/blog/$postId'
    | '/challenges/$challengeId'
    | '/challenges/daily-guides'
    | '/events/$eventId'
    | '/faqs/$faqId'
    | '/faqs/new'
    | '/inquiries/rooms'
    | '/newsletters/$newsletterId'
    | '/newsletters/categories'
    | '/newsletters/new'
    | '/notices/$noticeId'
    | '/notices/new'
    | '/resources/unsubscribe-lambda'
    | '/resources/unsubscribe-parse-pattern'
    | '/resources/unsubscribe-pattern'
    | '/reviewers/stats'
    | '/blog/'
    | '/challenges/'
    | '/events/'
    | '/faqs/'
    | '/inquiries/'
    | '/newsletters'
    | '/notices/'
    | '/resources/'
    | '/reviewers'
    | '/challenges/$challengeId/teams'
    | '/faqs/$faqId/edit'
    | '/newsletters/$newsletterId/edit'
    | '/newsletters/$newsletterId/previous'
    | '/notices/$noticeId/edit'
    | '/resources/unsubscribe-lambda/editor'
    | '/challenges/$challengeId/'
    | '/faqs/$faqId/'
    | '/newsletters/$newsletterId/'
    | '/notices/$noticeId/'
    | '/resources/unsubscribe-lambda/'
    | '/newsletters/$newsletterId/previous/$articleId'
    | '/newsletters/$newsletterId/previous/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/403'
    | '/erd'
    | '/flyway'
    | '/members'
    | '/'
    | '/blog/$postId'
    | '/challenges/daily-guides'
    | '/events/$eventId'
    | '/faqs/new'
    | '/inquiries/rooms'
    | '/newsletters/categories'
    | '/newsletters/new'
    | '/notices/new'
    | '/resources/unsubscribe-parse-pattern'
    | '/resources/unsubscribe-pattern'
    | '/reviewers/stats'
    | '/blog'
    | '/challenges'
    | '/events'
    | '/faqs'
    | '/inquiries'
    | '/newsletters'
    | '/notices'
    | '/resources'
    | '/reviewers'
    | '/challenges/$challengeId/teams'
    | '/faqs/$faqId/edit'
    | '/newsletters/$newsletterId/edit'
    | '/notices/$noticeId/edit'
    | '/resources/unsubscribe-lambda/editor'
    | '/challenges/$challengeId'
    | '/faqs/$faqId'
    | '/newsletters/$newsletterId'
    | '/notices/$noticeId'
    | '/resources/unsubscribe-lambda'
    | '/newsletters/$newsletterId/previous/$articleId'
    | '/newsletters/$newsletterId/previous';
  id:
    | '__root__'
    | '/403'
    | '/_admin'
    | '/_admin/blog'
    | '/_admin/challenges'
    | '/_admin/erd'
    | '/_admin/events'
    | '/_admin/faqs'
    | '/_admin/flyway'
    | '/_admin/inquiries'
    | '/_admin/members'
    | '/_admin/notices'
    | '/_admin/resources'
    | '/_admin/'
    | '/_admin/blog/$postId'
    | '/_admin/challenges/$challengeId'
    | '/_admin/challenges/daily-guides'
    | '/_admin/events/$eventId'
    | '/_admin/faqs/$faqId'
    | '/_admin/faqs/new'
    | '/_admin/inquiries/rooms'
    | '/_admin/newsletters/$newsletterId'
    | '/_admin/newsletters/categories'
    | '/_admin/newsletters/new'
    | '/_admin/notices/$noticeId'
    | '/_admin/notices/new'
    | '/_admin/resources/unsubscribe-lambda'
    | '/_admin/resources/unsubscribe-parse-pattern'
    | '/_admin/resources/unsubscribe-pattern'
    | '/_admin/reviewers/stats'
    | '/_admin/blog/'
    | '/_admin/challenges/'
    | '/_admin/events/'
    | '/_admin/faqs/'
    | '/_admin/inquiries/'
    | '/_admin/newsletters/'
    | '/_admin/notices/'
    | '/_admin/resources/'
    | '/_admin/reviewers/'
    | '/_admin/challenges/$challengeId/teams'
    | '/_admin/faqs/$faqId/edit'
    | '/_admin/newsletters/$newsletterId/edit'
    | '/_admin/newsletters/$newsletterId/previous'
    | '/_admin/notices/$noticeId/edit'
    | '/_admin/resources/unsubscribe-lambda/editor'
    | '/_admin/challenges/$challengeId/'
    | '/_admin/faqs/$faqId/'
    | '/_admin/newsletters/$newsletterId/'
    | '/_admin/notices/$noticeId/'
    | '/_admin/resources/unsubscribe-lambda/'
    | '/_admin/newsletters/$newsletterId/previous/$articleId'
    | '/_admin/newsletters/$newsletterId/previous/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  R403Route: typeof R403Route;
  AdminRoute: typeof AdminRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/403': {
      id: '/403';
      path: '/403';
      fullPath: '/403';
      preLoaderRoute: typeof R403RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_admin/': {
      id: '/_admin/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/resources': {
      id: '/_admin/resources';
      path: '/resources';
      fullPath: '/resources';
      preLoaderRoute: typeof AdminResourcesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/notices': {
      id: '/_admin/notices';
      path: '/notices';
      fullPath: '/notices';
      preLoaderRoute: typeof AdminNoticesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/members': {
      id: '/_admin/members';
      path: '/members';
      fullPath: '/members';
      preLoaderRoute: typeof AdminMembersRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/inquiries': {
      id: '/_admin/inquiries';
      path: '/inquiries';
      fullPath: '/inquiries';
      preLoaderRoute: typeof AdminInquiriesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/flyway': {
      id: '/_admin/flyway';
      path: '/flyway';
      fullPath: '/flyway';
      preLoaderRoute: typeof AdminFlywayRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/faqs': {
      id: '/_admin/faqs';
      path: '/faqs';
      fullPath: '/faqs';
      preLoaderRoute: typeof AdminFaqsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/events': {
      id: '/_admin/events';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof AdminEventsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/erd': {
      id: '/_admin/erd';
      path: '/erd';
      fullPath: '/erd';
      preLoaderRoute: typeof AdminErdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/challenges': {
      id: '/_admin/challenges';
      path: '/challenges';
      fullPath: '/challenges';
      preLoaderRoute: typeof AdminChallengesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/blog': {
      id: '/_admin/blog';
      path: '/blog';
      fullPath: '/blog';
      preLoaderRoute: typeof AdminBlogRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/reviewers/': {
      id: '/_admin/reviewers/';
      path: '/reviewers';
      fullPath: '/reviewers';
      preLoaderRoute: typeof AdminReviewersIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/resources/': {
      id: '/_admin/resources/';
      path: '/';
      fullPath: '/resources/';
      preLoaderRoute: typeof AdminResourcesIndexRouteImport;
      parentRoute: typeof AdminResourcesRoute;
    };
    '/_admin/notices/': {
      id: '/_admin/notices/';
      path: '/';
      fullPath: '/notices/';
      preLoaderRoute: typeof AdminNoticesIndexRouteImport;
      parentRoute: typeof AdminNoticesRoute;
    };
    '/_admin/newsletters/': {
      id: '/_admin/newsletters/';
      path: '/newsletters';
      fullPath: '/newsletters';
      preLoaderRoute: typeof AdminNewslettersIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/inquiries/': {
      id: '/_admin/inquiries/';
      path: '/';
      fullPath: '/inquiries/';
      preLoaderRoute: typeof AdminInquiriesIndexRouteImport;
      parentRoute: typeof AdminInquiriesRoute;
    };
    '/_admin/faqs/': {
      id: '/_admin/faqs/';
      path: '/';
      fullPath: '/faqs/';
      preLoaderRoute: typeof AdminFaqsIndexRouteImport;
      parentRoute: typeof AdminFaqsRoute;
    };
    '/_admin/events/': {
      id: '/_admin/events/';
      path: '/';
      fullPath: '/events/';
      preLoaderRoute: typeof AdminEventsIndexRouteImport;
      parentRoute: typeof AdminEventsRoute;
    };
    '/_admin/challenges/': {
      id: '/_admin/challenges/';
      path: '/';
      fullPath: '/challenges/';
      preLoaderRoute: typeof AdminChallengesIndexRouteImport;
      parentRoute: typeof AdminChallengesRoute;
    };
    '/_admin/blog/': {
      id: '/_admin/blog/';
      path: '/';
      fullPath: '/blog/';
      preLoaderRoute: typeof AdminBlogIndexRouteImport;
      parentRoute: typeof AdminBlogRoute;
    };
    '/_admin/reviewers/stats': {
      id: '/_admin/reviewers/stats';
      path: '/reviewers/stats';
      fullPath: '/reviewers/stats';
      preLoaderRoute: typeof AdminReviewersStatsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/resources/unsubscribe-pattern': {
      id: '/_admin/resources/unsubscribe-pattern';
      path: '/unsubscribe-pattern';
      fullPath: '/resources/unsubscribe-pattern';
      preLoaderRoute: typeof AdminResourcesUnsubscribePatternRouteImport;
      parentRoute: typeof AdminResourcesRoute;
    };
    '/_admin/resources/unsubscribe-parse-pattern': {
      id: '/_admin/resources/unsubscribe-parse-pattern';
      path: '/unsubscribe-parse-pattern';
      fullPath: '/resources/unsubscribe-parse-pattern';
      preLoaderRoute: typeof AdminResourcesUnsubscribeParsePatternRouteImport;
      parentRoute: typeof AdminResourcesRoute;
    };
    '/_admin/resources/unsubscribe-lambda': {
      id: '/_admin/resources/unsubscribe-lambda';
      path: '/unsubscribe-lambda';
      fullPath: '/resources/unsubscribe-lambda';
      preLoaderRoute: typeof AdminResourcesUnsubscribeLambdaRouteImport;
      parentRoute: typeof AdminResourcesRoute;
    };
    '/_admin/notices/new': {
      id: '/_admin/notices/new';
      path: '/new';
      fullPath: '/notices/new';
      preLoaderRoute: typeof AdminNoticesNewRouteImport;
      parentRoute: typeof AdminNoticesRoute;
    };
    '/_admin/notices/$noticeId': {
      id: '/_admin/notices/$noticeId';
      path: '/$noticeId';
      fullPath: '/notices/$noticeId';
      preLoaderRoute: typeof AdminNoticesNoticeIdRouteImport;
      parentRoute: typeof AdminNoticesRoute;
    };
    '/_admin/newsletters/new': {
      id: '/_admin/newsletters/new';
      path: '/newsletters/new';
      fullPath: '/newsletters/new';
      preLoaderRoute: typeof AdminNewslettersNewRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/newsletters/categories': {
      id: '/_admin/newsletters/categories';
      path: '/newsletters/categories';
      fullPath: '/newsletters/categories';
      preLoaderRoute: typeof AdminNewslettersCategoriesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/newsletters/$newsletterId': {
      id: '/_admin/newsletters/$newsletterId';
      path: '/newsletters/$newsletterId';
      fullPath: '/newsletters/$newsletterId';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdRouteImport;
      parentRoute: typeof AdminRoute;
    };
    '/_admin/inquiries/rooms': {
      id: '/_admin/inquiries/rooms';
      path: '/rooms';
      fullPath: '/inquiries/rooms';
      preLoaderRoute: typeof AdminInquiriesRoomsRouteImport;
      parentRoute: typeof AdminInquiriesRoute;
    };
    '/_admin/faqs/new': {
      id: '/_admin/faqs/new';
      path: '/new';
      fullPath: '/faqs/new';
      preLoaderRoute: typeof AdminFaqsNewRouteImport;
      parentRoute: typeof AdminFaqsRoute;
    };
    '/_admin/faqs/$faqId': {
      id: '/_admin/faqs/$faqId';
      path: '/$faqId';
      fullPath: '/faqs/$faqId';
      preLoaderRoute: typeof AdminFaqsFaqIdRouteImport;
      parentRoute: typeof AdminFaqsRoute;
    };
    '/_admin/events/$eventId': {
      id: '/_admin/events/$eventId';
      path: '/$eventId';
      fullPath: '/events/$eventId';
      preLoaderRoute: typeof AdminEventsEventIdRouteImport;
      parentRoute: typeof AdminEventsRoute;
    };
    '/_admin/challenges/daily-guides': {
      id: '/_admin/challenges/daily-guides';
      path: '/daily-guides';
      fullPath: '/challenges/daily-guides';
      preLoaderRoute: typeof AdminChallengesDailyGuidesRouteImport;
      parentRoute: typeof AdminChallengesRoute;
    };
    '/_admin/challenges/$challengeId': {
      id: '/_admin/challenges/$challengeId';
      path: '/$challengeId';
      fullPath: '/challenges/$challengeId';
      preLoaderRoute: typeof AdminChallengesChallengeIdRouteImport;
      parentRoute: typeof AdminChallengesRoute;
    };
    '/_admin/blog/$postId': {
      id: '/_admin/blog/$postId';
      path: '/$postId';
      fullPath: '/blog/$postId';
      preLoaderRoute: typeof AdminBlogPostIdRouteImport;
      parentRoute: typeof AdminBlogRoute;
    };
    '/_admin/resources/unsubscribe-lambda/': {
      id: '/_admin/resources/unsubscribe-lambda/';
      path: '/';
      fullPath: '/resources/unsubscribe-lambda/';
      preLoaderRoute: typeof AdminResourcesUnsubscribeLambdaIndexRouteImport;
      parentRoute: typeof AdminResourcesUnsubscribeLambdaRoute;
    };
    '/_admin/notices/$noticeId/': {
      id: '/_admin/notices/$noticeId/';
      path: '/';
      fullPath: '/notices/$noticeId/';
      preLoaderRoute: typeof AdminNoticesNoticeIdIndexRouteImport;
      parentRoute: typeof AdminNoticesNoticeIdRoute;
    };
    '/_admin/newsletters/$newsletterId/': {
      id: '/_admin/newsletters/$newsletterId/';
      path: '/';
      fullPath: '/newsletters/$newsletterId/';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdIndexRouteImport;
      parentRoute: typeof AdminNewslettersNewsletterIdRoute;
    };
    '/_admin/faqs/$faqId/': {
      id: '/_admin/faqs/$faqId/';
      path: '/';
      fullPath: '/faqs/$faqId/';
      preLoaderRoute: typeof AdminFaqsFaqIdIndexRouteImport;
      parentRoute: typeof AdminFaqsFaqIdRoute;
    };
    '/_admin/challenges/$challengeId/': {
      id: '/_admin/challenges/$challengeId/';
      path: '/';
      fullPath: '/challenges/$challengeId/';
      preLoaderRoute: typeof AdminChallengesChallengeIdIndexRouteImport;
      parentRoute: typeof AdminChallengesChallengeIdRoute;
    };
    '/_admin/resources/unsubscribe-lambda/editor': {
      id: '/_admin/resources/unsubscribe-lambda/editor';
      path: '/editor';
      fullPath: '/resources/unsubscribe-lambda/editor';
      preLoaderRoute: typeof AdminResourcesUnsubscribeLambdaEditorRouteImport;
      parentRoute: typeof AdminResourcesUnsubscribeLambdaRoute;
    };
    '/_admin/notices/$noticeId/edit': {
      id: '/_admin/notices/$noticeId/edit';
      path: '/edit';
      fullPath: '/notices/$noticeId/edit';
      preLoaderRoute: typeof AdminNoticesNoticeIdEditRouteImport;
      parentRoute: typeof AdminNoticesNoticeIdRoute;
    };
    '/_admin/newsletters/$newsletterId/previous': {
      id: '/_admin/newsletters/$newsletterId/previous';
      path: '/previous';
      fullPath: '/newsletters/$newsletterId/previous';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdPreviousRouteImport;
      parentRoute: typeof AdminNewslettersNewsletterIdRoute;
    };
    '/_admin/newsletters/$newsletterId/edit': {
      id: '/_admin/newsletters/$newsletterId/edit';
      path: '/edit';
      fullPath: '/newsletters/$newsletterId/edit';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdEditRouteImport;
      parentRoute: typeof AdminNewslettersNewsletterIdRoute;
    };
    '/_admin/faqs/$faqId/edit': {
      id: '/_admin/faqs/$faqId/edit';
      path: '/edit';
      fullPath: '/faqs/$faqId/edit';
      preLoaderRoute: typeof AdminFaqsFaqIdEditRouteImport;
      parentRoute: typeof AdminFaqsFaqIdRoute;
    };
    '/_admin/challenges/$challengeId/teams': {
      id: '/_admin/challenges/$challengeId/teams';
      path: '/teams';
      fullPath: '/challenges/$challengeId/teams';
      preLoaderRoute: typeof AdminChallengesChallengeIdTeamsRouteImport;
      parentRoute: typeof AdminChallengesChallengeIdRoute;
    };
    '/_admin/newsletters/$newsletterId/previous/': {
      id: '/_admin/newsletters/$newsletterId/previous/';
      path: '/';
      fullPath: '/newsletters/$newsletterId/previous/';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdPreviousIndexRouteImport;
      parentRoute: typeof AdminNewslettersNewsletterIdPreviousRoute;
    };
    '/_admin/newsletters/$newsletterId/previous/$articleId': {
      id: '/_admin/newsletters/$newsletterId/previous/$articleId';
      path: '/$articleId';
      fullPath: '/newsletters/$newsletterId/previous/$articleId';
      preLoaderRoute: typeof AdminNewslettersNewsletterIdPreviousArticleIdRouteImport;
      parentRoute: typeof AdminNewslettersNewsletterIdPreviousRoute;
    };
  }
}

interface AdminBlogRouteChildren {
  AdminBlogPostIdRoute: typeof AdminBlogPostIdRoute;
  AdminBlogIndexRoute: typeof AdminBlogIndexRoute;
}

const AdminBlogRouteChildren: AdminBlogRouteChildren = {
  AdminBlogPostIdRoute: AdminBlogPostIdRoute,
  AdminBlogIndexRoute: AdminBlogIndexRoute,
};

const AdminBlogRouteWithChildren = AdminBlogRoute._addFileChildren(
  AdminBlogRouteChildren,
);

interface AdminChallengesChallengeIdRouteChildren {
  AdminChallengesChallengeIdTeamsRoute: typeof AdminChallengesChallengeIdTeamsRoute;
  AdminChallengesChallengeIdIndexRoute: typeof AdminChallengesChallengeIdIndexRoute;
}

const AdminChallengesChallengeIdRouteChildren: AdminChallengesChallengeIdRouteChildren =
  {
    AdminChallengesChallengeIdTeamsRoute: AdminChallengesChallengeIdTeamsRoute,
    AdminChallengesChallengeIdIndexRoute: AdminChallengesChallengeIdIndexRoute,
  };

const AdminChallengesChallengeIdRouteWithChildren =
  AdminChallengesChallengeIdRoute._addFileChildren(
    AdminChallengesChallengeIdRouteChildren,
  );

interface AdminChallengesRouteChildren {
  AdminChallengesChallengeIdRoute: typeof AdminChallengesChallengeIdRouteWithChildren;
  AdminChallengesDailyGuidesRoute: typeof AdminChallengesDailyGuidesRoute;
  AdminChallengesIndexRoute: typeof AdminChallengesIndexRoute;
}

const AdminChallengesRouteChildren: AdminChallengesRouteChildren = {
  AdminChallengesChallengeIdRoute: AdminChallengesChallengeIdRouteWithChildren,
  AdminChallengesDailyGuidesRoute: AdminChallengesDailyGuidesRoute,
  AdminChallengesIndexRoute: AdminChallengesIndexRoute,
};

const AdminChallengesRouteWithChildren = AdminChallengesRoute._addFileChildren(
  AdminChallengesRouteChildren,
);

interface AdminEventsRouteChildren {
  AdminEventsEventIdRoute: typeof AdminEventsEventIdRoute;
  AdminEventsIndexRoute: typeof AdminEventsIndexRoute;
}

const AdminEventsRouteChildren: AdminEventsRouteChildren = {
  AdminEventsEventIdRoute: AdminEventsEventIdRoute,
  AdminEventsIndexRoute: AdminEventsIndexRoute,
};

const AdminEventsRouteWithChildren = AdminEventsRoute._addFileChildren(
  AdminEventsRouteChildren,
);

interface AdminFaqsFaqIdRouteChildren {
  AdminFaqsFaqIdEditRoute: typeof AdminFaqsFaqIdEditRoute;
  AdminFaqsFaqIdIndexRoute: typeof AdminFaqsFaqIdIndexRoute;
}

const AdminFaqsFaqIdRouteChildren: AdminFaqsFaqIdRouteChildren = {
  AdminFaqsFaqIdEditRoute: AdminFaqsFaqIdEditRoute,
  AdminFaqsFaqIdIndexRoute: AdminFaqsFaqIdIndexRoute,
};

const AdminFaqsFaqIdRouteWithChildren = AdminFaqsFaqIdRoute._addFileChildren(
  AdminFaqsFaqIdRouteChildren,
);

interface AdminFaqsRouteChildren {
  AdminFaqsFaqIdRoute: typeof AdminFaqsFaqIdRouteWithChildren;
  AdminFaqsNewRoute: typeof AdminFaqsNewRoute;
  AdminFaqsIndexRoute: typeof AdminFaqsIndexRoute;
}

const AdminFaqsRouteChildren: AdminFaqsRouteChildren = {
  AdminFaqsFaqIdRoute: AdminFaqsFaqIdRouteWithChildren,
  AdminFaqsNewRoute: AdminFaqsNewRoute,
  AdminFaqsIndexRoute: AdminFaqsIndexRoute,
};

const AdminFaqsRouteWithChildren = AdminFaqsRoute._addFileChildren(
  AdminFaqsRouteChildren,
);

interface AdminInquiriesRouteChildren {
  AdminInquiriesRoomsRoute: typeof AdminInquiriesRoomsRoute;
  AdminInquiriesIndexRoute: typeof AdminInquiriesIndexRoute;
}

const AdminInquiriesRouteChildren: AdminInquiriesRouteChildren = {
  AdminInquiriesRoomsRoute: AdminInquiriesRoomsRoute,
  AdminInquiriesIndexRoute: AdminInquiriesIndexRoute,
};

const AdminInquiriesRouteWithChildren = AdminInquiriesRoute._addFileChildren(
  AdminInquiriesRouteChildren,
);

interface AdminNoticesNoticeIdRouteChildren {
  AdminNoticesNoticeIdEditRoute: typeof AdminNoticesNoticeIdEditRoute;
  AdminNoticesNoticeIdIndexRoute: typeof AdminNoticesNoticeIdIndexRoute;
}

const AdminNoticesNoticeIdRouteChildren: AdminNoticesNoticeIdRouteChildren = {
  AdminNoticesNoticeIdEditRoute: AdminNoticesNoticeIdEditRoute,
  AdminNoticesNoticeIdIndexRoute: AdminNoticesNoticeIdIndexRoute,
};

const AdminNoticesNoticeIdRouteWithChildren =
  AdminNoticesNoticeIdRoute._addFileChildren(AdminNoticesNoticeIdRouteChildren);

interface AdminNoticesRouteChildren {
  AdminNoticesNoticeIdRoute: typeof AdminNoticesNoticeIdRouteWithChildren;
  AdminNoticesNewRoute: typeof AdminNoticesNewRoute;
  AdminNoticesIndexRoute: typeof AdminNoticesIndexRoute;
}

const AdminNoticesRouteChildren: AdminNoticesRouteChildren = {
  AdminNoticesNoticeIdRoute: AdminNoticesNoticeIdRouteWithChildren,
  AdminNoticesNewRoute: AdminNoticesNewRoute,
  AdminNoticesIndexRoute: AdminNoticesIndexRoute,
};

const AdminNoticesRouteWithChildren = AdminNoticesRoute._addFileChildren(
  AdminNoticesRouteChildren,
);

interface AdminResourcesUnsubscribeLambdaRouteChildren {
  AdminResourcesUnsubscribeLambdaEditorRoute: typeof AdminResourcesUnsubscribeLambdaEditorRoute;
  AdminResourcesUnsubscribeLambdaIndexRoute: typeof AdminResourcesUnsubscribeLambdaIndexRoute;
}

const AdminResourcesUnsubscribeLambdaRouteChildren: AdminResourcesUnsubscribeLambdaRouteChildren =
  {
    AdminResourcesUnsubscribeLambdaEditorRoute:
      AdminResourcesUnsubscribeLambdaEditorRoute,
    AdminResourcesUnsubscribeLambdaIndexRoute:
      AdminResourcesUnsubscribeLambdaIndexRoute,
  };

const AdminResourcesUnsubscribeLambdaRouteWithChildren =
  AdminResourcesUnsubscribeLambdaRoute._addFileChildren(
    AdminResourcesUnsubscribeLambdaRouteChildren,
  );

interface AdminResourcesRouteChildren {
  AdminResourcesUnsubscribeLambdaRoute: typeof AdminResourcesUnsubscribeLambdaRouteWithChildren;
  AdminResourcesUnsubscribeParsePatternRoute: typeof AdminResourcesUnsubscribeParsePatternRoute;
  AdminResourcesUnsubscribePatternRoute: typeof AdminResourcesUnsubscribePatternRoute;
  AdminResourcesIndexRoute: typeof AdminResourcesIndexRoute;
}

const AdminResourcesRouteChildren: AdminResourcesRouteChildren = {
  AdminResourcesUnsubscribeLambdaRoute:
    AdminResourcesUnsubscribeLambdaRouteWithChildren,
  AdminResourcesUnsubscribeParsePatternRoute:
    AdminResourcesUnsubscribeParsePatternRoute,
  AdminResourcesUnsubscribePatternRoute: AdminResourcesUnsubscribePatternRoute,
  AdminResourcesIndexRoute: AdminResourcesIndexRoute,
};

const AdminResourcesRouteWithChildren = AdminResourcesRoute._addFileChildren(
  AdminResourcesRouteChildren,
);

interface AdminNewslettersNewsletterIdPreviousRouteChildren {
  AdminNewslettersNewsletterIdPreviousArticleIdRoute: typeof AdminNewslettersNewsletterIdPreviousArticleIdRoute;
  AdminNewslettersNewsletterIdPreviousIndexRoute: typeof AdminNewslettersNewsletterIdPreviousIndexRoute;
}

const AdminNewslettersNewsletterIdPreviousRouteChildren: AdminNewslettersNewsletterIdPreviousRouteChildren =
  {
    AdminNewslettersNewsletterIdPreviousArticleIdRoute:
      AdminNewslettersNewsletterIdPreviousArticleIdRoute,
    AdminNewslettersNewsletterIdPreviousIndexRoute:
      AdminNewslettersNewsletterIdPreviousIndexRoute,
  };

const AdminNewslettersNewsletterIdPreviousRouteWithChildren =
  AdminNewslettersNewsletterIdPreviousRoute._addFileChildren(
    AdminNewslettersNewsletterIdPreviousRouteChildren,
  );

interface AdminNewslettersNewsletterIdRouteChildren {
  AdminNewslettersNewsletterIdEditRoute: typeof AdminNewslettersNewsletterIdEditRoute;
  AdminNewslettersNewsletterIdPreviousRoute: typeof AdminNewslettersNewsletterIdPreviousRouteWithChildren;
  AdminNewslettersNewsletterIdIndexRoute: typeof AdminNewslettersNewsletterIdIndexRoute;
}

const AdminNewslettersNewsletterIdRouteChildren: AdminNewslettersNewsletterIdRouteChildren =
  {
    AdminNewslettersNewsletterIdEditRoute:
      AdminNewslettersNewsletterIdEditRoute,
    AdminNewslettersNewsletterIdPreviousRoute:
      AdminNewslettersNewsletterIdPreviousRouteWithChildren,
    AdminNewslettersNewsletterIdIndexRoute:
      AdminNewslettersNewsletterIdIndexRoute,
  };

const AdminNewslettersNewsletterIdRouteWithChildren =
  AdminNewslettersNewsletterIdRoute._addFileChildren(
    AdminNewslettersNewsletterIdRouteChildren,
  );

interface AdminRouteChildren {
  AdminBlogRoute: typeof AdminBlogRouteWithChildren;
  AdminChallengesRoute: typeof AdminChallengesRouteWithChildren;
  AdminErdRoute: typeof AdminErdRoute;
  AdminEventsRoute: typeof AdminEventsRouteWithChildren;
  AdminFaqsRoute: typeof AdminFaqsRouteWithChildren;
  AdminFlywayRoute: typeof AdminFlywayRoute;
  AdminInquiriesRoute: typeof AdminInquiriesRouteWithChildren;
  AdminMembersRoute: typeof AdminMembersRoute;
  AdminNoticesRoute: typeof AdminNoticesRouteWithChildren;
  AdminResourcesRoute: typeof AdminResourcesRouteWithChildren;
  AdminIndexRoute: typeof AdminIndexRoute;
  AdminNewslettersNewsletterIdRoute: typeof AdminNewslettersNewsletterIdRouteWithChildren;
  AdminNewslettersCategoriesRoute: typeof AdminNewslettersCategoriesRoute;
  AdminNewslettersNewRoute: typeof AdminNewslettersNewRoute;
  AdminReviewersStatsRoute: typeof AdminReviewersStatsRoute;
  AdminNewslettersIndexRoute: typeof AdminNewslettersIndexRoute;
  AdminReviewersIndexRoute: typeof AdminReviewersIndexRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminBlogRoute: AdminBlogRouteWithChildren,
  AdminChallengesRoute: AdminChallengesRouteWithChildren,
  AdminErdRoute: AdminErdRoute,
  AdminEventsRoute: AdminEventsRouteWithChildren,
  AdminFaqsRoute: AdminFaqsRouteWithChildren,
  AdminFlywayRoute: AdminFlywayRoute,
  AdminInquiriesRoute: AdminInquiriesRouteWithChildren,
  AdminMembersRoute: AdminMembersRoute,
  AdminNoticesRoute: AdminNoticesRouteWithChildren,
  AdminResourcesRoute: AdminResourcesRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminNewslettersNewsletterIdRoute:
    AdminNewslettersNewsletterIdRouteWithChildren,
  AdminNewslettersCategoriesRoute: AdminNewslettersCategoriesRoute,
  AdminNewslettersNewRoute: AdminNewslettersNewRoute,
  AdminReviewersStatsRoute: AdminReviewersStatsRoute,
  AdminNewslettersIndexRoute: AdminNewslettersIndexRoute,
  AdminReviewersIndexRoute: AdminReviewersIndexRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  R403Route: R403Route,
  AdminRoute: AdminRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
